<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">Participation at Club Officers Workshop | Month: {{ month }}</h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5" v-if="officerWorkshops && !loading">
        <v-row>         
          <v-col cols="4" md="4" sm="12">
            <div class="subtitle-1">No of attended officers </div>
            <div class="caption">{{ officerWorkshops.attended_officers_number }}</div>
          </v-col>
          <v-col cols="4" md="4" sm="12">
            <div class="subtitle-1">President Attended</div>
            <div class="caption">{{ officerWorkshops.president_attended == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
          <v-col cols="4" md="4" sm="12">
            <div class="subtitle-1">Secretary attended</div>
            <div class="caption">{{ officerWorkshops.secretary_attended == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
         <v-row>     
          <v-col cols="4" md="4" sm="12">
            <div class="subtitle-1">Treasurer Attended</div>
            <div class="caption">{{ officerWorkshops.treasurer_attended == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
          <v-col cols="4" md="4" sm="12">
            <div class="subtitle-1">Membership Director of the club</div>
            <div class="caption">{{ officerWorkshops.membership_director_attended == 1 ? 'Yes' : 'No' }}</div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="officerWorkshops.documents && officerWorkshops.documents.length > 0">
          <v-col cols="12" md="6" sm="12">
            <div class="subtitle-1">Attached copy of the certificate</div>
            <div class="caption">
              <a :href="officerWorkshops.documents[0].path" target="_blank">View certificate</a>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-form>
    </v-card>   
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import GoBackBtn from "@/components/shared/GoBackBtn";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "NewClubOfficerWorkshopsView",

  components: { GoBackBtn, Alert, Snackbars },

  data: () => ({
    month: "",
    role: localStorage.getItem("role"),
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      pending_comment: "",
    },
    boardMeeting: [],
    confirm: false,
    officerWorkshops: [],
  }),

  mounted() {
    this.month = this.$route.params.month;
    this.getOfficerWorkshops();
  },

  computed: {
    ...mapGetters({
      defaultExam: "defaultExam",
      defaultSubject: "defaultSubject",
    }),
  },

  methods: {
    getOfficerWorkshops() {
      if (this.$route.params.aId !== null) {
        this.loading = true;
        ActivityService.getActivityInfo("new-club-officer-workshops", this.$route.params.aId)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {            
              this.officerWorkshops = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;        
            this.officerWorkshops = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
    pending() {},
    submit() {},
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
